import axios from 'axios'
import { getConfigAxios } from './config'

function get(axiosParams) {
  const configAxios = getConfigAxios()
  return axios.get(axiosParams.url, configAxios)
}

function getTokenAPI(axiosParams) {
  const configAxios = getConfigAxios(axiosParams.tokenAPI)
  return axios.get(axiosParams.url, configAxios)
}

function post(axiosParams, data) {
  const configAxios = getConfigAxios()
  return axios.post(axiosParams.url, data, configAxios)
}

function postTokenAPI(axiosParams, data) {
  const configAxios = getConfigAxios(axiosParams.tokenAPI)
  return axios.post(axiosParams.url, data, configAxios)
}

function put(axiosParams, data) {
  const configAxios = getConfigAxios()
  return axios.put(axiosParams.url, data, configAxios)
}

const axiosWrapper = {
  get,
  getTokenAPI,
  post,
  postTokenAPI,
  put
}

export default axiosWrapper
